import { render, staticRenderFns } from "./dispatch_person.vue?vue&type=template&id=55fd7e9c&scoped=true"
import script from "./dispatch_person.vue?vue&type=script&lang=js"
export * from "./dispatch_person.vue?vue&type=script&lang=js"
import style0 from "./dispatch_person.vue?vue&type=style&index=0&id=55fd7e9c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fd7e9c",
  null
  
)

export default component.exports